<template>
  <div id="day-titles">
    <el-row :gutter="24">
      <slot />
      <el-col :span="1" :offset="5" class="ta-c p0"> Надо </el-col>
      <el-col :span="4" class="ta-c"> Откликов </el-col>
      <el-col :span="2" class="ta-c"> Недобор </el-col>
      <el-col :span="3" class="ta-c"> Документы </el-col>
      <el-col :span="3" class="ta-c"> Цена </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'DaysTitles',
}
</script>

<style lang="sass">
#day-titles
  padding: 0 20px
  .p0
    padding: 0 !important
</style>
